import React, { useContext, useEffect, useState, useRef } from 'react';
import Scrollbars from "react-custom-scrollbars";
import ChapterForm from './ChapterForm';
import { Context } from "../contexts/AppContext";
import { postData, getData, putData } from "../../lib/utils";

function VideoAdvanceSetting(props) {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [chapterArr, setChapterArr] = useState([]);
  const [isAdding, setIsAdding] = useState(false);

  const scrollRef = useRef(null);

  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollToBottom();
    }
  };

  const addChapterHandler = async () => {
    if (isAdding) return;
    setIsAdding(true);
    try {
      const json = await postData("chapters/createChapter", {
        title: `Chapter ${chapterArr.length}`,
        cuePoint: props.currentTime,
        videoId: appState.currentDBVideoId,
      });

      if (json) {
        setChapterArr((prevChapters) => [
          ...prevChapters,
          { ...json, title: json.title, cuePoint: json.cuePoint }
        ]);
        setTimeout(() => scrollToBottom(), 100); // scroll neeche le jao
      }
    } catch (err) {
      console.error("Error creating chapter:", err);
    } finally {
      setIsAdding(false);
    }
  };

  // Load chapters
  useEffect(() => {
    (async () => {
      const data = await getData(
        `chapters/getChaptersByVideo/${appState.currentDBVideoId}`
      );
      setChapterArr(data);
    })();
  }, [appState.currentDBVideoId]);

  const updateAllChapters = async () => {
    try {
      await Promise.all(
        chapterArr.map((ch) =>
          putData(`chapters/updatechapters/${ch._id}`, {
            title: ch.title,
            cuePoint: ch.cuePoint,
            videoId: appState.currentDBVideoId,
          })
        )
      );
      alert("All chapters updated successfully!");
    } catch (err) {
      console.error("Error updating chapters:", err);
    }
  };

const sortAllChaptersByTime = async () => {
  try {
    const res = await postData(
      `chapters/sortChaptersByTime/${appState.currentDBVideoId}`,
      { chapters: chapterArr }
    );

    if (res && res.chapters) {
      console.log("response bro", res.chapters);
      
      // ✅ Update UI with sorted chapters
      setChapterArr(res.chapters);
      alert("All Chapters Updated Successfully")
    } else {
      console.warn("No sorted chapters returned");
    }
  } catch (err) {
    console.error("Error sorting chapters:", err);
  }
};


  return (
    <div className='mt-2 px-4 space-y-4'>
      <label className="block mb-2 text-sm font-medium text-yellow-800 dark:text-white">
        Chapters      
      </label> 

      <button
        onClick={addChapterHandler}
        type="button"
        className="w-full text-white bg-[#b99c6b] font-medium text-sm px-5 py-2.5"
      >         
        Add Chapter At {props.currentTime}
      </button>

      <div className='bg-white border w-full h-auto items-center justify-center'>
        <Scrollbars ref={scrollRef} autoHeight autoHeightMin={100} autoHeightMax={320}>
          <ChapterForm chapterArr={chapterArr} setChapterArr={setChapterArr}  currentTime={props.currentTime}  />
        </Scrollbars>
      </div> 

      <button
        onClick={sortAllChaptersByTime}
        type="button"
        className="w-full text-white bg-green-600 font-medium text-sm px-5 py-2.5 mt-2"
      >
        Update All Chapters
      </button>
      
    </div>
  )
}

export default VideoAdvanceSetting;
